<template>
  <section class="section about" id="about">
    <div class="wrap">
      <div class="sec-head reveal" v-reveal>
        <p class="sec-eyebrow">05 / ABOUT / 关于</p>
      </div>
      <p class="about-lead reveal" v-reveal>我们先把 AI 用进<br>自己的公司, 再拿来帮你做项目。</p>
      <div class="about-grid">
        <div class="about-item reveal" v-reveal>
          <span class="mono">01 / 底盘</span>
          <h3>十年工程功底</h3>
          <p>微信生态、网站、APP, 我们干了十年。AI 是放大器, 放大的是这份底子。</p>
        </div>
        <div class="about-item reveal" v-reveal>
          <span class="mono">02 / 方式</span>
          <h3>全公司都是 AI-Native</h3>
          <p>不只是开发在用。销售、产品、设计、测试、运维, 每个岗位都有 AI 搭档。</p>
        </div>
        <div class="about-item reveal" v-reveal>
          <span class="mono">03 / 态度</span>
          <h3>做不到的不接</h3>
          <p>合作前先给结论: 能做的才接, 做不了直说。不浪费你的时间, 也不浪费我们的。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection'
}
</script>

<style scoped>
.about {
  background: var(--dark);
  color: var(--dark-ink);
}

.about :deep(.sec-eyebrow) {
  color: #6E9BFF;
}

.about :deep(.sec-head h2) {
  color: var(--dark-ink);
}

.about-lead {
  font-size: 34px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.3px;
  max-width: 680px;
  margin-bottom: 60px;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.about-item h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--dark-ink);
}

.about-item p {
  font-size: 14px;
  color: var(--dark-ink-2);
}

.about-item .mono {
  font-family: var(--mono);
  font-size: 12px;
  color: #6E9BFF;
  display: block;
  margin-bottom: 14px;
}

@media (max-width: 860px) {
  .about-lead {
    font-size: 26px;
  }

  .about-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}
</style>
